import { UPGRADE_PATHS } from "@circle-react-shared/UpgradePlan/constants";
import { useCurrentPlanApi } from "@circle-react/components/SettingsApp/Plan/hooks/useCurrentPlanApi";
import { useEffect } from "react";

import { t } from "@/i18n-js/instance";

import { Loader } from "./Loader";
import { useUpgradePlanNavigate } from "./upgradePlanRouterHelpers";

const i18nRoot = "pricing_plans.upgrade_modal";
export const EmailHubSubscriptionCheck = () => {
  const { currentPlan, refetchCurrentPlan } = useCurrentPlanApi();
  const navigate = useUpgradePlanNavigate();

  const isEmailHubEnabled =
    currentPlan?.email_hub_billing?.email_hub_billing_active;

  useEffect(() => {
    const intervalId = setInterval(() => {
      void refetchCurrentPlan();
    }, 1000);
    return () => clearInterval(intervalId);
  }, [refetchCurrentPlan]);

  useEffect(() => {
    if (isEmailHubEnabled) {
      void navigate({ to: UPGRADE_PATHS.UPGRADE_SUCCESSFUL });
    }
  }, [isEmailHubEnabled, navigate]);

  return (
    <Loader
      title={t([i18nRoot, "loading.creating_email_hub_subscription"])}
      subtitle={t("pricing_plans.upgrade_modal.updating_plan_description")}
    />
  );
};
